import React, { useState } from "react";
import Modal from "react-responsive-modal";
import Button from "components/CustomButton";
import CustomTextArea from "components/CustomTextArea";
import { useFormik } from "formik";
import * as Yup from "yup";
import Scrollbar from "react-scrollbars-custom";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import AIService from "services/AIService";
import Loader from "components/Loader";
import ChatgptIcon from "assets/img/icons/chatgpt-logo.png";
import classNames from "classnames";

function ChatGptAssistModal({ setValue, setHide = null }) {
  const [showModal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [chatGptResponse, setChatGptResponse] = useState(null);
  const [loadedImage, setLoadImage] = useState(false);

  const formik = useFormik({
    initialValues: {
      query: "",
    },
    validateOnBlur: false,
    validationSchema: Yup.object().shape({
      query: Yup.string().trim().required("Please add your query."),
    }),
    onSubmit: async (values) => {
      if (loading) return;
      setLoading(true);
      var response = await AIService.chatgptAssist({
        query: values.query.endsWith("?")
          ? values.query
          : values.query.concat("?"),
      });

      var res = response.data.text.split("\n");
      var res2 = res.slice(2);

      setChatGptResponse(res2);
      setLoading(false);
    },
  });

  const handleModal = () => {
    setModal(!showModal);
    if (setHide) {
      setHide(!showModal);
    }
    setChatGptResponse(null);
    setLoading(false);
    formik.resetForm();
  };

  const keepValue = () => {
    setModal(!showModal);
    if (setHide) {
      setHide(!showModal);
    }
    setValue(chatGptResponse.join("\n"));
    setChatGptResponse(null);
    formik.resetForm();
  };

  const loadImage = (e) => {
    setLoadImage(true);
  };

  return (
    <>
      <img
        src={ChatgptIcon}
        onLoad={loadImage}
        className={classNames({
          "chat-gpt-icon": true,
          "chat-gpt-background": loadedImage ? true : false,
        })}
        alt="chat-gpt"
        onClick={handleModal}
      />
      <Modal
        open={showModal}
        onClose={handleModal}
        showCloseIcon={false}
        classNames={{
          modalContainer: "modalContainer",
          modal: "queryModalContainer",
        }}
      >
        <div className="confirmationModalContent">
          <div className="chatGptQueryHeader">
            <h5 className="text-center confirmationModalHeader">
              Get help from ReTeam Assistant
            </h5>
            <span className="chatgptCloseModal">
              <CancelIcon className="closeIcon" onClick={handleModal} />
            </span>
          </div>
          <hr />
          <div className="chatGptQueryContent">
            <form noValidate onSubmit={formik.handleSubmit}>
              <div className="chatGptQuery">
                <span className="query-heading">Your Query</span>
                <CustomTextArea
                  scrollActivate={false}
                  errorClass="textStyle"
                  textAreaClass="form-control write-comments"
                  formik={formik}
                  placeholder="Write your query here"
                  fieldName={"query"}
                  limit={500}
                  rows={1}
                />
                <div className="query-footer">
                  <Button buttonClass="grad_btn query-btn" disabled={loading}>
                    {!loading ? "Submit" : <Loader width={25} height={25} />}
                  </Button>
                </div>
              </div>
              <div className="chatGptResponseRoot">
                <span className="responseHeading">
                  ReTeam Assistant's Response
                </span>
                <div className="chatGptQuery">
                  <Scrollbar>
                    <div>
                      {chatGptResponse?.map((line, index) => (
                        <p key={index}>{line}</p>
                      ))}
                    </div>
                  </Scrollbar>
                </div>
              </div>
            </form>
          </div>
          <div className="chat-gpt-footer">
            <Button
              disabled={!chatGptResponse ? true : false}
              buttonClass=" small-reject-btn chat-gpt-response-reject"
              onClick={handleModal}
            >
              Reject
            </Button>
            <Button
              disabled={!chatGptResponse ? true : false}
              buttonClass="small-accept-btn me-2 chat-gpt-response-accept"
              onClick={keepValue}
            >
              Accept
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ChatGptAssistModal;
